import React from 'react'
import { ScrollDimModal } from '~/app/components'
import { useRouter } from 'next/router'
import TrainInformation from '~/app/components/order-list/details/TrainInformtaion/TrainInformation'
import { useRerender } from '~/app/components/common/ForceRerenderProvider'

/**
 * TrainInformationModal component
 * author: soojin.oh
 */

type TrainInformationModalProps = {
  isOpened: boolean
  categoryOrderId: string
}

// styled components
const TARGET_ID = 'train-information'
// TrainInformationModal component
const TrainInformationModal: React.FC<TrainInformationModalProps> = function ({
  isOpened,
  categoryOrderId,
}) {
  const { back } = useRouter()
  const { rerender } = useRerender()

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <TrainInformation
        categoryOrderId={categoryOrderId}
        onClickBack={() => {
          back()
          rerender()
        }}
      />
    </ScrollDimModal>
  )
}

export default TrainInformationModal
